import React from 'react';
import Link from 'gatsby-link';
import Helmet from 'react-helmet';
import styles from './styles.module.css';

import BackgroundContainer from '../../components/background-container';

import GridWrap from '../../components/grid-wrap';
import SiteFooter from '../../components/site-footer';
import SubHeading from '../../components/sub-heading';

import RoomImage from '../../images/room.jpg';
import TileOneImage from '../../images/tile-one.jpg';
import TileTwoImage from '../../images/tile-two.jpg';

const IndexPage = () => (
  <div>
    <Helmet title="History of Whitefriars" />
    <BackgroundContainer src={RoomImage}>
      <div className={styles.top}>
        <GridWrap>
          <div className={styles.topContent}>
            <h1>Whitefriars</h1>
            <p>
              In 1923 James Powell and Sons, later to become Whitefriars Glass
              Limited, opened a factory on Tudor Road, Wealdstone in Harrow.
              Relocating there from the crowded and smoggy corner of the City of
              London, where it had been based since 1680.
            </p>
          </div>
        </GridWrap>
      </div>
    </BackgroundContainer>
    <GridWrap>
      <div className={styles.content}>
        <SubHeading text="The City of London Glassworks" />
        <p>
          The original Whitefriars site was located close to the River Thames.
          This meant that sand, clay, coal and other materials used in the glass
          making process could easily be transported to the Factory. This useful
          location had previously been a monastery of the Carmelite Fathers
          (founded in 1241), whose white habits earned the monks the nickname
          ‘White Friars’.
        </p>
        <SubHeading text="New Horizons" />
        <p>
          But with limited room to grow the firm began construction of
          &ldquo;the largest and most extensive glass works in the world&rdquo;
          in Harrow, on the North West edge of London.
        </p>
        <p>
          However, the final factory at Wealdstone ended up being much smaller
          than originally intended, at less than half the size, and with only
          two furnaces rather than three. In 1923 a lit brazier was carried from
          the old glasshouse to the new factory. It was used to light the first
          furnace, continuing the burning of the flame from the city glasshouse
          furnaces which had burnt continuously since 1680.
        </p>
        <p>
          In 1962 the firm was renamed Whitefriars Glass Limited. And the
          following year the modern, recognisable logo of a stylised friar was
          introduced. Harking back to the original site of the glassworks in the
          City of London.
        </p>
        <SubHeading text="The Closure of the works" />
        <p>
          In October 1980, after 300 years of glassmaking and only 57 years in
          Wealdstone, the Whitefriars Glass Factory finally closed its doors.
          Following this closure, the site was cleared and the buildings
          demolished.
        </p>
        <p>
          Despite its closure, Whitefriars continues to be recognised was a
          world leader of the glassmaking industry; famous for its iconic
          designs and colours. Whitefriars produced beautiful objects combining
          the effective use of modern machinery and ancient methods and
          continues to be valued for its quality and beauty.
        </p>
      </div>
    </GridWrap>
    <SiteFooter />
  </div>
);

export default IndexPage;



// WEBPACK FOOTER //
// ./src/page-components/history/index.js